import axios from 'axios';
import axiosInstance from 'utils/axiosInstance';
import { usersUrls } from 'constants/urls';

const sendLoginCode = ({ phone }) => {
  return axios.post(usersUrls.sendLoginCode, { phone, role: '' });
};

const loginApi = ({ activationCodeId, code }) => {
  return axios.post(usersUrls.login, { activationCodeId, code });
};

const signup = ({ medicalNumber, nationalCode }) => {
  return axiosInstance.post(usersUrls.register, {
    medicalNumber,
    nationalCode,
    isAgent: false
  });
};

export { loginApi, sendLoginCode, signup };
